{
  "version": 1,
  "asset_id": "1b78bf9e-834e-418f-b919-0fab1def07c8",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/1b78bf9e-834e-418f-b919-0fab1def07c8/g21.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/1b78bf9e-834e-418f-b919-0fab1def07c8/g21.jpg",
  "original_filename": "g21.jpg",
  "size": 70619,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T23:00:11Z"
}
